import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
export default function BusinessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "icon-business",
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.916 19.481l-.91-5.739a4 4 0 013.325-4.577l8.133-1.29A4 4 0 0134.04 11.2l.91 5.739",
    stroke: "#0064E1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.106 23.443l48.104-7.628 4.706 29.674a2 2 0 01-1.663 2.289L10.1 54.779a2 2 0 01-2.288-1.662L3.106 23.443z",
    fill: "#0064E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.039 22.468A2 2 0 013.7 20.178l45.934-7.284a2 2 0 012.289 1.662l2.622 16.538a2 2 0 01-1.662 2.289L6.95 40.667a2 2 0 01-2.289-1.662L2.04 22.467z",
    fill: "#0064E1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D9F",
    d: "M5.865 40.84l48.104-7.628.565 3.564L6.43 44.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.492 33.252a.402.402 0 01.334-.46l3.66-.58a.402.402 0 01.46.333l1.42 8.957a2.255 2.255 0 01-4.454.706l-1.42-8.956z",
    fill: "#E6EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DC3FF",
    d: "M28.135 37.309l4.454-.706.565 3.563-4.454.706z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E6DEB",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M29.672 40.618l2.479-.393"
  }));
}